import { ApiError, login, playAsGuest, register } from "../api/AuthClient.js";
import { appState, persistSession } from "../state/AppState.js";

export function renderLoginScreen(container: HTMLElement): void {
  container.innerHTML = `
    <div class="screen">
      <div class="panel" style="width: 360px;">
        <h1 class="panel-title">Wardlines</h1>
        <p class="panel-subtitle">Cooperative & competitive tower defense</p>
        <div class="form-row">
          <label>Username</label>
          <input id="username" type="text" autocomplete="username" />
        </div>
        <div class="form-row">
          <label>Password</label>
          <input id="password" type="password" autocomplete="current-password" />
        </div>
        <div class="error-text" id="error"></div>
        <div class="btn-row">
          <button id="login-btn" class="primary" style="flex:1">Sign in</button>
          <button id="register-btn" style="flex:1">Create account</button>
        </div>
        <div class="btn-row">
          <button id="guest-btn" style="flex:1">Play as guest</button>
        </div>
      </div>
    </div>
  `;

  const usernameInput = container.querySelector<HTMLInputElement>("#username")!;
  const passwordInput = container.querySelector<HTMLInputElement>("#password")!;
  const errorEl = container.querySelector<HTMLDivElement>("#error")!;
  const loginBtn = container.querySelector<HTMLButtonElement>("#login-btn")!;
  const registerBtn = container.querySelector<HTMLButtonElement>("#register-btn")!;
  const guestBtn = container.querySelector<HTMLButtonElement>("#guest-btn")!;

  function readableError(err: unknown): string {
    if (err instanceof ApiError) {
      switch (err.code) {
        case "INVALID_CREDENTIALS": return "Invalid username or password";
        case "USERNAME_TAKEN": return "Username already taken";
        case "INVALID_USERNAME": return "Username must be 3-20 alphanumeric/underscore characters";
        case "VALIDATION_ERROR": return "Password must be at least 8 characters";
        case "TOO_MANY_GUESTS": return "Too many guest sessions from this network, try again later";
        default: return err.code;
      }
    }
    return "Network error";
  }

  async function submit(action: "login" | "register" | "guest"): Promise<void> {
    const username = usernameInput.value.trim();
    const password = passwordInput.value;
    if (action !== "guest" && (!username || !password)) {
      errorEl.textContent = "Username and password required";
      return;
    }
    errorEl.textContent = "";
    loginBtn.disabled = true;
    registerBtn.disabled = true;
    guestBtn.disabled = true;
    try {
      const res =
        action === "guest" ? await playAsGuest() : await (action === "login" ? login : register)(username, password);
      persistSession(res.token, res.refreshToken, res.user);
      appState.set({ token: res.token, refreshToken: res.refreshToken, user: res.user, screen: "lobby" });
    } catch (err) {
      errorEl.textContent = readableError(err);
    } finally {
      loginBtn.disabled = false;
      registerBtn.disabled = false;
      guestBtn.disabled = false;
    }
  }

  loginBtn.addEventListener("click", () => void submit("login"));
  registerBtn.addEventListener("click", () => void submit("register"));
  guestBtn.addEventListener("click", () => void submit("guest"));
  passwordInput.addEventListener("keydown", (e) => {
    if (e.key === "Enter") void submit("login");
  });
}
